import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import { ButtonWithIcon } from '@els/els-react--button';
import { LinkElement } from '@els/els-react--link-element';
import { Flyout } from '@els/els-react--flyout';
import NamedUserContainer from '@Containers/Header/DashboardNavigation/NamedUser/NamedUserContainer';
import GeneralMenuItems from '../GeneralMenuItems';

import './HamburgerMenu.scss';

export default function HamburgerMenu({ isAnonymousUser, openRegisterDialog, goToLogin }) {
  const [isFlyoutOpen, setIsFlyoutOpen] = useState(false);
  const flyoutRef = useRef(null);
  const options = [
    {
      id: 'access-dropdown-register',
      text: 'Register',
      iconSprite: 'Edit',
      ariaLabel: 'Open registration dialog',
      href: '#',
      onClick: (e) => {
        e.preventDefault();
        Logger.info('Register');
        setIsFlyoutOpen(false);
        openRegisterDialog();
      },
      a11y: { name: 'Register', description: 'Open registration dialog' },
    },
    {
      id: 'access-dropdown-login',
      text: 'Sign in',
      iconSprite: 'LogIn',
      ariaLabel: 'Go to login page',
      href: '#',
      onClick: (e) => {
        e.preventDefault();
        Logger.info('Log in');
        goToLogin();
      },
      a11y: { name: 'Login', description: 'Go to login page' },
    },
  ];

  const closeFlyout = useCallback(() => {
    setIsFlyoutOpen(false);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (flyoutRef.current && !flyoutRef.current.contains(event.target)) {
        closeFlyout(); // Close the pop-up
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [closeFlyout]);

  return (
    <li className="rx-menu-item hamburger-menu-toggler u-els-display-none u-els-display-inline@tablet">
      <Flyout
        isControlled
        isOpen={isFlyoutOpen}
        placement="bottom-end"
        pointer
        pointerType="primary"
        flyout={
          <div ref={flyoutRef}>
            <span className="u-els-font-size-h4 u-els-display-block u-els-margin-bottom-3o4">Main Menu</span>
            <GeneralMenuItems onItemClick={() => setIsFlyoutOpen(false)} />
            {isAnonymousUser && (
              <>
                <div className="rx-menu-item u-els-margin-bottom-3o4" aria-label="Reaxys Access options">
                  <h4 className="u-els-font-size-h4">Reaxys Access</h4>
                </div>
                <ul className="rx-menu rx-menu--vertical">
                  {options.map((option) => (
                    <li key={option.id} className="rx-menu-item">
                      <LinkElement
                        iconSprite={option.iconSprite}
                        iconSize="xs"
                        href={option.href}
                        onClick={option.onClick}
                        a11y={option.a11y}
                        className={option.className}>
                        {option.text}
                      </LinkElement>
                    </li>
                  ))}
                </ul>
              </>
            )}
            {!isAnonymousUser && <NamedUserContainer closeFlyout={closeFlyout} />}
          </div>
        }>
        <ButtonWithIcon
          id="hamburger-menu-toggler"
          sprite="Menu"
          type="borderless"
          iconOnly
          className="u-els-margin-left-1x cp"
          onClick={() => setIsFlyoutOpen(!isFlyoutOpen)}>
          Menu Option
        </ButtonWithIcon>
      </Flyout>
    </li>
  );
}

HamburgerMenu.propTypes = {
  openRegisterDialog: PropTypes.func.isRequired,
  goToLogin: PropTypes.func.isRequired,
  isAnonymousUser: PropTypes.bool,
};
